import {ImageOpDefinition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {DataType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {EvaluatedParameters} from "@cm/graph-v2-final"
import {z} from "zod"

export const imageOpHalOptions = z
    .object({
        usePhysicalOutputImage: z.boolean().optional(), // default: false
        physicalOutputDataType: DataType.optional(), // default: float32
    })
    .optional()
export type ImageOpHalOptions = z.infer<typeof imageOpHalOptions>

export type ImageOpHalParameters<Definition extends ImageOpDefinition> = EvaluatedParameters<ImageOpParametersOfType<Definition, "hal">>

export type ExtUpdateImageOptions = UpdateImageOptions & {cachingEnabled: boolean}

export type CachingStrategy =
    | "never" // never store in atlas for reuse
    | "always" // always store in atlas for reuse
    | "auto" // automatically determine based on number of updates before invalidation

export type UpdateImageOptions = {
    priority?: number // default: 0; highest priority is processed first
    abortSignal?: AbortSignal
}
